import React from "react";
import { motion } from "motion/react";

const ContactCard = ({ icon, title, para }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: false, amount: 0.5 }}
      className=" h-48 text-center  flex items-center flex-col border rounded-2xl py-4 bg-gray-50 "
    >
      <p className="text-speed-red drop-shadow-lg text-4xl">{icon}</p>
      <p className="text-lg my-4 font-bold ">{title}</p>
      {Array.isArray(para) ? (
        <>
          {" "}
          {para?.map((v, i) => {
            return (
              <p key={i} className="text-deep-grey">
                {v}
              </p>
            );
          })}
        </>
      ) : (
        <p className="text-deep-grey">{para}</p>
      )}
    </motion.div>
  );
};

export default ContactCard;
